import React, { useState, useEffect } from "react"
import { CheckIcon } from "@atos6/icons"

type Props = {
  src: string
}

export function Img(props: Props) {
  const [showPlaceholder, setShowPlaceholder] = useState(false)

  useEffect(resetPlaceholderState, [props.src])

  function resetPlaceholderState() {
    setShowPlaceholder(false)
  }

  function onError() {
    setShowPlaceholder(true)
  }

  return showPlaceholder ? (
    <ImgPlaceholder />
  ) : (
    <img style={style} alt="upload" src={props.src} onError={onError} />
  )
}

function ImgPlaceholder() {
  return <CheckIcon />
}

// FIXME: Criar estilo reutilizável
const style: React.CSSProperties = {
  maxHeight: "100%",
  maxWidth: "100%",
}
